import * as React from "react";
const SvgUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 9, viewBox: "0 0 16 9", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M 0 8 L 6.5858 1.4142 C 7.3668 0.6332 8.6332 0.6332 9.4142 1.4142 L 17 9 L -1 9 Z", fill: "currentColor" }));
export default SvgUp;
